import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import {
  GridLayout,
  GridLayoutItem,
  TabStrip,
  TabStripTab,
} from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormTextField from "../../components/formFields/FormTextField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  createPurchase,
  updatePurchase,
  getPurchaseById,
} from "./services/purchase.services";
import { clearPurchaseDetails } from "./purchaseSlice";
import { findAllActiveProductSubCategory } from "../productsubcategory/services/productsubcategory.services";
import { findAllActiveParty } from "../party/services/party.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import { findAllActiveItem } from "../item/services/item.services";
import { IParty } from "../party/partyModel";
import PurchaseOrderDetailArray from "./PurchaseOrderDetailArray";
import { ErrorToast } from "../../components/toast/Toasts";
import PurchaseDetailArray from "./PurchaseOrderEntryArray";
import { findAllActivePurity } from "../purity/services/purity.services";
import { findAllActiveKarigar } from "../karigar/services/karigar.services";

const purchaseTypes = [
  { value: "Antique", label: "Antique" },
  { value: "Diamonds", label: "Diamonds" },
  {
    value: "Other Gold Products",
    label: "Other Gold Products",
  },
  { value: "Stone Purchase", label: "Stone Purchase" },
  { value: "Loose Gold Item", label: "Loose Gold Item" },
];

const CreatePurchaseForm: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const purchaseID = location?.state?.ID;
  const loading = useAppSelector((state) => state.purchase?.loading);
  const formLoading = useAppSelector((state) => state.purchase?.formLoading);
  const PurchaseSave = useAppSelector((state) => state.purchase?.PurchaseSave);
  const PurityList = useAppSelector((state) => state.purity.PurityList);
  const PurchaseDetail = useAppSelector(
    (state) => state.purchase?.PurchaseDetail,
  );
  const [selectedTab, setSelectedTab] = useState(0);
  const [formKey, setFormKey] = useState(1);
  const veparyList = useAppSelector((state) => state.party?.PartyList);
  const ItemList = useAppSelector((state) => state.item.ItemList);

  useEffect(() => {
    dispatch(findAllActivePurity());
    dispatch(findAllActiveParty());
    dispatch(findAllActiveItemCategory());
    dispatch(findAllActiveProductSubCategory());
    dispatch(findAllActiveItem());
    dispatch(findAllActiveKarigar());

    return () => {
      dispatch(clearPurchaseDetails());
    };
  }, []);

  useEffect(() => {
    if (purchaseID) {
      dispatch(getPurchaseById(purchaseID));
    }
  }, [purchaseID]);

  useEffect(() => {
    if (PurchaseDetail) {
      setFormKey(formKey + 1);
      // Set selected tab based on PurchaseType
      const tabIndex = purchaseTypes.findIndex(
        (type) => type.value === PurchaseDetail?.PurchaseType,
      );
      if (tabIndex !== -1) setSelectedTab(tabIndex);
    }
  }, [PurchaseDetail]);

  const getPurchaseEntryCountByType = (
    type: string,
    formRenderProps: FormRenderProps,
  ) => {
    const purchaseList = formRenderProps.valueGetter("PurchaseForm");
    return (
      purchaseList?.filter((item: any) => item.PurchaseType === type)?.length ||
      0
    );
  };

  const handleSubmit = async (values: any) => {
    if (PurchaseSave) return false;

    if (!values.PurchaseForm || !values.PurchaseForm.length) {
      ErrorToast("Please add at least one Order Entry or Gold Issue Entry.");
      return;
    }

    const formData = {
      Date: values.Date ? moment(values.Date).format("YYYY-MM-DD") : "",
      VeparyID: values.VeparyID ? +values.VeparyID : null,
      InvoiceNo: values.InvoiceNo ? values.InvoiceNo : null,
      // PurchaseType: values.PurchaseType || "",
      IsActive: values.IsActive === 1,
      PurchaseForm:
        values.PurchaseForm?.map((item: any) => ({
          PurchaseType: item.PurchaseType || "",
          ProductCategoryID: item.ProductCategoryID
            ? +item.ProductCategoryID
            : null,
          ProductSubCategoryID: item.ProductSubCategoryID
            ? +item.ProductSubCategoryID
            : null,
          ProductID: item.ProductID ? +item.ProductID : null,
          UniqueProductID: item.UniqueProductID || "",
          GrossWeight: item.GrossWeight || 0,
          NetWeight: item.NetWeight || 0,
          Remarks: item.Remarks || "",
          Purity: item.Purity || 0,
          Wastage: item.Wastage || 0,
          PhinePayble: item.PhinePayble || 0,
          TotalRSPayable: item.TotalRSPayable || 0,
          PCS: item.PCS || 0,
          PurchaseFormChild:
            item.PurchaseFormChild?.map((child: any) => ({
              ItemID: child.ItemID || 0,
              Weight: child.Weight || 0,
              StonePcs: child.StonePcs || 0,
              CTWeight: child.CTWeight || 0,
              Charges: child.Charges || 0,
              CustomeWeight: child.CustomeWeight || 0,
              ChargesForLable: child.ChargesForLable || 0,
            })) || [],
          DiamondWeight: item.DiamondWeight || 0,
          LabelLessWtForDiamond: item.LabelLessWtForDiamond || 0,
          DiamondChargesPerCt: item.DiamondChargesPerCt || 0,
          DiamondChargesTotal: item.DiamondChargesTotal || 0,
          PerCaretDiamondCharges: item.PerCaretDiamondCharges || 0,
          OtherStoneWeight: item.OtherStoneWeight || 0,
          LabelLessWeightForStone: item.LabelLessWeightForStone || 0,
          OtherChargesChargeBySupplier: item.OtherChargesChargeBySupplier || 0,
          OtherChargesForLable: item.OtherChargesForLable || 0,
          LabourPerGram: item.LabourPerGram || 0,
          TotalLabour: item.TotalLabour || 0,
          LessWeight: item.LessWeight || 0,
          LessWeightForLabel: item.LessWeightForLabel || 0,
          OtherCharges: item.OtherCharges || 0,
          LabourChargesForLabel: item.LabourChargesForLabel || 0,
          StoneBagNo: item.StoneBagNo || 0,
          GMCT: item.GMCT || "",
          RatePerGramCT: item.RatePerGramCT || 0,
        })) || [],
    };

    if (purchaseID) {
      const editPayload = {
        ID: purchaseID,
        ...formData,
      };
      const response = await dispatch(updatePurchase(editPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        navigate("/purchaseentry");
      }
    } else {
      const response = await dispatch(createPurchase(formData));
      if (response?.meta?.requestStatus === "fulfilled") {
        navigate("/purchaseentry");
      }
    }
  };

  const handleFormClose = () => {
    navigate("/purchaseentry");
  };

  const handleSelectProductInArray = ({
    formRenderProps,
    index,
    e,
  }: {
    formRenderProps: FormRenderProps;
    index: number;
    e: any;
  }) => {
    if (!e && !e?.value) return;
    const product = ItemList?.find((item) => item.id === e.value);
    if (product) {
      formRenderProps.onChange(`PurchaseForm.${index}.Purity`, {
        value: product?.purity_id,
      });
    } else {
      formRenderProps.onChange(`PurchaseForm.${index}.Purity`, { value: 0 });
    }
  };

  const handleChangePayblePhine = ({
    formRenderProps,
    index,
  }: {
    formRenderProps: FormRenderProps;
    index: number;
  }) => {
    const given_NetWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.NetWeight`) || 0;
    const given_purity =
      PurityList?.find(
        (purity: any) =>
          purity.ID ===
          formRenderProps.valueGetter(`PurchaseForm.${index}.Purity`),
      )?.purity || 0;
    const given_wastage =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.Wastage`) || 0;
    let phine = (given_NetWeight * (+given_purity + given_wastage)) / 100;
    if (given_NetWeight && given_purity) {
      formRenderProps.onChange(`PurchaseForm.${index}.PhinePayble`, {
        value: phine.toFixed(3),
      });
    }
  };

  const handleChangeGoldField = ({
    formRenderProps,
    index,
  }: {
    formRenderProps: FormRenderProps;
    index: number;
  }) => {
    const GrossWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.GrossWeight`) || 0;
    const LessWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.LessWeight`) || 0;
    let NetWeight = GrossWeight - LessWeight;
    formRenderProps.onChange(`PurchaseForm.${index}.NetWeight`, {
      value: NetWeight.toFixed(3),
    });

    const given_purity =
      PurityList?.find(
        (purity: any) =>
          purity.ID ===
          formRenderProps.valueGetter(`PurchaseForm.${index}.Purity`),
      )?.purity || 0;
    const given_wastage =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.Wastage`) || 0;
    let phine = (NetWeight * (+given_purity + given_wastage)) / 100;
    if (NetWeight && given_purity) {
      formRenderProps.onChange(`PurchaseForm.${index}.PhinePayble`, {
        value: phine.toFixed(3),
      });
    }
  };

  const handleChangeStoneField = ({
    formRenderProps,
    index,
  }: {
    formRenderProps: FormRenderProps;
    index: number;
  }) => {
    const GrossWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.GrossWeight`) || 0;
    const LessWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.LessWeight`) || 0;
    let NetWeight = GrossWeight - LessWeight;
    formRenderProps.onChange(`PurchaseForm.${index}.NetWeight`, {
      value: NetWeight.toFixed(3),
    });

    const given_purity =
      PurityList?.find(
        (purity: any) =>
          purity.ID ===
          formRenderProps.valueGetter(`PurchaseForm.${index}.Purity`),
      )?.purity || 0;
    const given_wastage =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.Wastage`) || 0;
    let phine = (NetWeight * (+given_purity + given_wastage)) / 100;
    if (NetWeight && given_purity) {
      formRenderProps.onChange(`PurchaseForm.${index}.PhinePayble`, {
        value: phine.toFixed(3),
      });
    }
  };

  const handleChangeDiamondField = ({
    formRenderProps,
    index,
  }: {
    formRenderProps: FormRenderProps;
    index: number;
  }) => {
    const given_NetWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.NetWeight`) || 0;
    const given_purity =
      PurityList?.find(
        (purity: any) =>
          purity.ID ===
          formRenderProps.valueGetter(`PurchaseForm.${index}.Purity`),
      )?.purity || 0;
    const given_wastage =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.Wastage`) || 0;
    let phine = (given_NetWeight * (+given_purity + given_wastage)) / 100;
    if (given_NetWeight && given_purity) {
      formRenderProps.onChange(`PurchaseForm.${index}.PhinePayble`, {
        value: phine.toFixed(3),
      });
    }

    const DiamondChargesPerCt =
      +formRenderProps.valueGetter(
        `PurchaseForm.${index}.DiamondChargesPerCt`,
      ) || 0;
    const WeightCarat =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.WeightCarat`) || 0;

    if (DiamondChargesPerCt || WeightCarat) {
      formRenderProps.onChange(`PurchaseForm.${index}.DiamondChargesTotal`, {
        value: (DiamondChargesPerCt * WeightCarat).toFixed(3),
      });
    }

    const GrossWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.GrossWeight`) || 0;
    const DiamondWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.DiamondWeight`) || 0;
    const OtherStoneWeight =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.OtherStoneWeight`) ||
      0;

    const NetWeight = (GrossWeight - DiamondWeight - OtherStoneWeight).toFixed(
      3,
    );

    if (GrossWeight || DiamondWeight || OtherStoneWeight) {
      formRenderProps.onChange(`PurchaseForm.${index}.NetWeight`, {
        value: NetWeight,
      });
    }

    const LabourPerGram =
      +formRenderProps.valueGetter(`PurchaseForm.${index}.LabourPerGram`) || 0;
    let TotalLabour = +NetWeight * LabourPerGram;
    formRenderProps.onChange(`PurchaseForm.${index}.TotalLabour`, {
      value: TotalLabour ? TotalLabour.toFixed(3) : 0,
    });

    const OtherChargesChargeBySupplier =
      +formRenderProps.valueGetter(
        `PurchaseForm.${index}.OtherChargesChargeBySupplier`,
      ) || 0;
    const DiamondChargesTotal =
      +formRenderProps.valueGetter(
        `PurchaseForm.${index}.DiamondChargesTotal`,
      ) || 0;
    const TotalRSPayable =
      TotalLabour + OtherChargesChargeBySupplier + DiamondChargesTotal;
    formRenderProps.onChange(`PurchaseForm.${index}.TotalRSPayable`, {
      value: TotalRSPayable ? TotalRSPayable.toFixed(3) : 0,
    });
  };

  const findPurityName = ({
    formRenderProps,
    index,
  }: {
    formRenderProps: FormRenderProps;
    index: number;
  }) => {
    const prurity = PurityList?.find(
      (purity: any) =>
        purity.ID ===
        formRenderProps.valueGetter(`PurchaseForm.${index}.Purity`),
    );
    return `${prurity?.Carat || ""}-${prurity?.purity || ""}`;
  };

  const handleTabSelect = (e: any, formRenderProps: FormRenderProps) => {
    const selectedIndex = e.selected;
    const selectedType = purchaseTypes[selectedIndex]?.value;
    setSelectedTab(selectedIndex);
    if (formRenderProps) {
      formRenderProps.onChange("PurchaseType", { value: selectedType });
    }
  };

  return (
    <>
      {(loading || formLoading) && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={PurchaseDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            {/* Header Section */}
            <ShadowCard style={{ padding: 12, marginBottom: 16 }}>
              <GridLayout
                style={{ paddingRight: 30 }}
                gap={{ rows: 0, cols: 16 }}
                cols={[
                  { width: "24.5%" },
                  { width: "24.5%" },
                  { width: "24.5%" },
                  { width: "24.5%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <Typography.h4 style={{ marginBottom: 16 }}>
                    {purchaseID ? "Update Purchase" : "New Purchase"}
                  </Typography.h4>
                </GridLayoutItem>

                <GridLayoutItem colSpan={4}>
                  {PurchaseDetail && (PurchaseDetail?.ID || 0) > 0 && (
                    <Typography.h5>
                      No :{" "}
                      <span style={{ color: "green" }}>
                        {PurchaseDetail.ID}
                      </span>
                    </Typography.h5>
                  )}
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="Date"
                    label="Purchase Date"
                    placeholder="dd/MM/yyyy"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="VeparyID"
                    label="Party Name"
                    placeholder="Select Party"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    isAddNew={true}
                    addNewLink="party/create"
                    dispatcherFunction={findAllActiveParty}
                    options={veparyList?.map((vepary: IParty) => ({
                      value: vepary.id,
                      label: vepary.party_name,
                    }))}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="InvoiceNo"
                    label="Invoice No"
                    placeholder="Enter Invoice No"
                    type="number"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name="PurchaseType"
                    label="Purchase Type"
                    placeholder="Select Type"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={purchaseTypes}
                    onChange={(e: any) => {
                      const selectedIndex = purchaseTypes.findIndex(
                        (type) => type.value === e.value,
                      );
                      if (selectedIndex !== -1) {
                        setSelectedTab(selectedIndex);
                      }
                    }}
                  />
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>

            {formRenderProps.valueGetter("PurchaseType") && (
              <ShadowCard>
                {/* Tabs for Purchase Types - ONLY THIS RENDERS THE FIELD ARRAY */}
                <TabStrip
                  selected={selectedTab}
                  onSelect={(e) => {
                    handleTabSelect(e, formRenderProps);
                  }}
                  style={{ marginBottom: 16 }}
                >
                  {purchaseTypes.map((type, idx) => (
                    <TabStripTab
                      key={idx}
                      title={
                        type.label +
                        ` (${getPurchaseEntryCountByType(type.value, formRenderProps)})`
                      }
                    >
                      <div style={{ padding: "16px 0" }}>
                        {type.value === "Antique" ? (
                          <FieldArray
                            formRenderProps={formRenderProps}
                            component={PurchaseOrderDetailArray}
                            handleSelectProductInArray={
                              handleSelectProductInArray
                            }
                            handleChangePayblePhine={handleChangePayblePhine}
                            handleChangeDiamondField={handleChangeDiamondField}
                            findPurityName={findPurityName}
                            handleChangeGoldField={handleChangeGoldField}
                            handleChangeStoneField={handleChangeStoneField}
                            name="PurchaseForm"
                          />
                        ) : (
                          <FieldArray
                            formRenderProps={formRenderProps}
                            component={PurchaseDetailArray}
                            handleSelectProductInArray={
                              handleSelectProductInArray
                            }
                            handleChangePayblePhine={handleChangePayblePhine}
                            handleChangeDiamondField={handleChangeDiamondField}
                            findPurityName={findPurityName}
                            handleChangeGoldField={handleChangeGoldField}
                            handleChangeStoneField={handleChangeStoneField}
                            name="PurchaseForm"
                          />
                        )}
                      </div>
                    </TabStripTab>
                  ))}
                </TabStrip>

                {/* REMOVED THE DUPLICATE FieldArray RENDERING HERE */}

                {/* Action Buttons */}
                <div style={{ padding: 12 }}>
                  <GridLayout cols={[{ width: "100%" }]}>
                    <GridLayoutItem
                      style={{
                        textAlign: "end",
                        width: "100%",
                        display: "flex",
                        gap: "8px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <ButtonWithLoading
                        label={
                          !purchaseID ? "Create Purchase" : "Update Purchase"
                        }
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={formLoading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        onClick={handleFormClose}
                      >
                        Cancel
                      </Button>
                    </GridLayoutItem>
                  </GridLayout>
                </div>
              </ShadowCard>
            )}
          </FormElement>
        )}
      />
    </>
  );
};

export default CreatePurchaseForm;
